/** top level key for local storage, with the subkey added to it */
const appKey = 'shifter'

/** save & track objects in local storage that are one type of thing */
export class PersistThings {
  constructor(private readonly subkey: string) { }

  /** get a list of the names of all things that have been saved */
  getSavedList(): string[] {
    const text = window.localStorage.getItem(this.getListKey());
    if (text !== null) {
      try {
        const list = JSON.parse(text);
        if (Array.isArray(list)) {
          return list;
        }
      } catch (error) { }
    }
    return [];
  }

  /** save & track a serialized thing */
  saveThing(name: string, thingAsString: string) {
    // add to list first to avoid orphans
    this.addToList(name);
    // save
    const key = this.getThingKey(name);
    window.localStorage.setItem(key, thingAsString);
  }

  /** load a serialized thing */
  loadThing(name: string): string | null {
    const key = this.getThingKey(name);
    return window.localStorage.getItem(key);
  }

  /** delete & stop tracking a thing */
  deleteThing(name: string) {
    // delete
    const key = this.getThingKey(name);
    window.localStorage.removeItem(key);
    // remove from list only after we've deleted the rule to avoid orphans
    this.removeFromList(name);
  }


  /** remember there's a new rule in our list */
  private addToList(ruleName: string) {
    const list = this.getSavedList();
    if (!list.includes(ruleName)) {
      const newList = list.concat(ruleName);
      this.saveNameList(newList);
    }
  }

  /** remove rule from our list */
  private removeFromList(ruleName: string) {
    const list = this.getSavedList();
    const newList = list.filter(s => s !== ruleName);
    this.saveNameList(newList);
  }

  /** save the list of all saved thing names */
  private saveNameList(list: string[]) {
    const key = this.getListKey();
    if (list.length === 0) {
      // no list, remove key
      window.localStorage.removeItem(key);
    } else {
      // save full list
      const text = JSON.stringify(list);
      window.localStorage.setItem(key, text);
    }
  }


  /** where the list of thing names is stored */
  private getListKey(): string {
    return `${appKey}/${this.subkey}[]`;
  }

  /** where a thing of a given name is stored */
  private getThingKey(name: string): string {
    return `${appKey}/${this.subkey}/${name}`;
  }
}
